<pai-header id="pai-header" />

<section id="pai-content" role="main">
  <ng-template routerOutlet />
</section>

<pai-footer id="pai-footer" />
